import { createContext, useContext } from 'react';

import { JSON, Serializable } from '../types';

export type MFEContextData<T> = Serializable<T>;

/**
 * Context used to pass data from the host to the MFEs
 */
export const MFEDataContext = createContext<JSON>({});

export function useMFEDataContext<T extends MFEContextData<T>>() {
    const context = useContext(MFEDataContext) as T;

    return context;
}
